import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
function Facilities() {
  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />

      {/* ================= BREADCRUMB / INNER SLIDER ================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Facilities"
          title2=""
          parentTitle="Facilities"
          path="Facilities"
        />
      </div>

      {/* ================= ABOUT CONTENT ================= */}
      <div className="innerbody">
        <div className="container-fluid">
          <div className="contact-form-card manage">
            <h2 className="about-title">Facilities</h2>

            <div className="about-content-card">
              {/* BULLET SECTION */}
              <p>
                Our convent school blends traditional values with modern
                infrastructure to provide a nurturing and future-ready learning
                environment. We offer a wide range of facilities designed to
                ensure academic excellence, personal growth, and student
                well-being.
              </p>
              <div className="affiliation-list mt-3">
                <div className="affiliation-item">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    <strong>Smart Classrooms:</strong> Digitally equipped
                    classrooms with interactive boards to make learning engaging
                    and effective.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    <strong>Science & Computer Laboratories:</strong>{" "}
                    Well-equipped physics, chemistry, biology, and computer labs
                    to promote hands-on learning and innovation.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    <strong>Library:</strong> A peaceful, well-stocked library
                    with a wide range of books, reference materials, and digital
                    resources.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    <strong>Spiritual Environment:</strong> Daily prayers, moral
                    education, and value-based learning rooted in the principles
                    of discipline and compassion.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    <strong>Playgrounds & Sports:</strong> Expansive play areas
                    for outdoor games, indoor sports facilities, and regular
                    physical education.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    <strong>Auditorium:</strong> Spacious halls for assemblies,
                    cultural programs, seminars, and school events.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    <strong>Safety & Security:</strong> CCTV surveillance, fire
                    safety measures, secure entry/exit, and a dedicated security
                    staff.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    <strong>Health & Hygiene:</strong> Regular health check-ups,
                    clean drinking water, sanitized toilets, and a medical room
                    with first-aid care.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    <strong>Transport Facility:</strong> GPS-enabled school
                    buses ensuring safe and punctual student transport.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    <strong>Eco-friendly Campus:</strong> Green surroundings,
                    cleanliness initiatives, and environmental awareness
                    programs.
                  </span>
                </div>

                <div className="affiliation-item mt-2">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/red-arrow.png"
                    alt="arrow"
                  />
                  <span>
                    <strong>Elevator:</strong> Elevator facility provided for
                    students from classes Kiddy to Class 2.
                  </span>
                </div>

                <p>
                  {" "}
                  Our school is committed to providing a well-rounded education
                  in a caring, disciplined, and technologically advanced
                  environment, preparing students to face the challenges of the
                  modern world with confidence and character.
                </p>
              </div>
            </div>
            <div className="container-fluid">
              <div className="row g-4">
                {/* Main Image */}
                <div className="col-12">
                  <div className="Fac-img main-fac-img">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/Facilities.jpg"
                      alt="School Facilities"
                    />
                  </div>
                </div>

                {/* Facility 1 */}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/Smart-Class.jpg"
                      alt="Smart Class"
                    />

                    <div className="facility-overlay">
                      <h5>Smart Class</h5>
                    </div>
                  </div>
                </div>

                {/* Facility 2 */}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/Computer-lab.jpg"
                      alt=" Computer Lab"
                    />

                    <div className="facility-overlay">
                      <h5> Computer Lab</h5>
                    </div>
                  </div>
                </div>

                {/* Facility 3 */}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/Chemistry-Lab.jpg"
                      alt="Library"
                    />

                    <div className="facility-overlay">
                      <h5>Chemistry Lab</h5>
                    </div>
                  </div>
                </div>

                {/* Facility 4 */}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/Physics-lab.jpg"
                      alt="Physics Lab"
                    />

                    <div className="facility-overlay">
                      <h5>Physics Lab</h5>
                    </div>
                  </div>
                </div>

                {/* Facility 5 */}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/Biology-lab.jpg"
                      alt="Biology Lab"
                    />

                    <div className="facility-overlay">
                      <h5>Biology Lab</h5>
                    </div>
                  </div>
                </div>
                {/* Facility 6*/}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/Library-Room.jpg"
                      alt="Library Room"
                    />

                    <div className="facility-overlay">
                      <h5>Library Room</h5>
                    </div>
                  </div>
                </div>
                {/* Facility 7*/}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/yoga.jpg"
                      alt="Yoga"
                    />

                    <div className="facility-overlay">
                      <h5>Yoga</h5>
                    </div>
                  </div>
                </div>
                {/* Facility 8*/}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/boxing.jpg"
                      alt="Kick Boxing"
                    />

                    <div className="facility-overlay">
                      <h5>Kick Boxing</h5>
                    </div>
                  </div>
                </div>
                {/* Facility 9*/}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/BASKETBALL.jpg"
                      alt="BasketBall Court"
                    />

                    <div className="facility-overlay">
                      <h5>BasketBall Court</h5>
                    </div>
                  </div>
                </div>
                {/* Facility 10*/}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/CCTV.jpg"
                      alt="CCTV Camera"
                    />

                    <div className="facility-overlay">
                      <h5>CCTV Camera</h5>
                    </div>
                  </div>
                </div>
                {/* Facility 11*/}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/bus.jpg"
                      alt="Bus "
                    />

                    <div className="facility-overlay">
                      <h5>Bus </h5>
                    </div>
                  </div>
                </div>
                {/* Facility 12*/}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/Extracurricular.JPG"
                      alt="Extra curricular "
                    />

                    <div className="facility-overlay">
                      <h5>Extra curricular </h5>
                    </div>
                  </div>
                </div>
                {/* Facility 13*/}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/Indoor-games.jpg"
                      alt="Indoor GAMES"
                    />

                    <div className="facility-overlay">
                      <h5>Indoor GAMES </h5>
                    </div>
                  </div>
                </div>
                {/* Facility 13*/}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/Band.JPG"
                      alt="School BAND"
                    />

                    <div className="facility-overlay">
                      <h5>School BAND</h5>
                    </div>
                  </div>
                </div>
                {/* Facility 14*/}
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="facility-card">
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/Lift.jpg"
                      alt="Lift Facility"
                    />

                    <div className="facility-overlay">
                      <h5>Lift Facility</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default Facilities;
